/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/swap'
export default icon
